import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const removeGroupInvoiceAdjustment = info =>
  call(websocketFetch, 'remove_group_invoice_ad_hoc_fee', info);
